<template>
  <el-dialog
    width="810px"
    class="top"
    :visible.sync="visible"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
  >
    <div id="dialog_table">
      <h1 class="text-center my-3">{{ $t('promotion.tradingRewards.allTiers') }}</h1>
      <el-table :data="rewardTiers" class="mb-2" :row-class-name="activeTableRow">
        <el-table-column prop="tier" :label="$t('promotion.tradingRewards.tier')" width="auto" />
        <el-table-column
          prop="notionalValue"
          :label="$t(`promotion.tradingRewards.rqmtTitle.${tradingMetric}`)"
          width="auto"
        />
        <el-table-column
          v-if="depositType"
          prop="depositAmount"
          :label="$t(`promotion.tradingRewards.${depositType}`)"
          width="auto"
        />
        <el-table-column
          :prop="rewardType == 'gift' ? 'reward' : 'rewardAmount'"
          :label="$t(rewardType ? `promotion.tradingRewards.${rewardType}` : 'promotion.tradingRewards.rewardUSD')"
          width="auto"
        />
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TierDetailsDialog',
  props: {
    tiersDialogVisible: Boolean,
    rewardTiers: Array,
    depositType: String,
    rewardType: String,
    tradingMetric: String,
    currentTier: Number
  },

  data() {
    return {
      visible: false
    };
  },
  computed: {
    showCurrentTierIndex() {
      return this.currentTier &&
        this.currentTier > 0 &&
        this.rewardTiers.filter(item => item.tier == this.currentTier).length > 0
        ? this.rewardTiers.findIndex(item => item.tier == this.currentTier)
        : 0;
    }
  },
  watch: {
    tiersDialogVisible(bool) {
      this.visible = bool;
    },
    visible(bool) {
      this.$emit('update:tiersDialogVisible', bool);
    }
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    activeTableRow({ row, rowIndex }) {
      if (rowIndex == this.showCurrentTierIndex && this.currentTier != 0) {
        return 'active-row';
      }
      return '';
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  margin-top: auto !important;
}

h1 {
  font-size: 20px;
  font-family: 'Oblivian-SemiBold';
  color: #000a2d;
}
</style>
